import { render, staticRenderFns } from "./ServiceCase.vue?vue&type=template&id=40a9e37b&scoped=true&"
import script from "./ServiceCase.vue?vue&type=script&lang=js&"
export * from "./ServiceCase.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCase.vue?vue&type=style&index=0&id=40a9e37b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9e37b",
  null
  
)

export default component.exports